<template>
	<div>
		<MedicationTable />
	</div>
</template>
  
<script>
/**
 * This file shows all currently stored medications and allows adding, editing, viewing and soft deleting these.
 */
import MedicationTable from "@/components/medication/medication/MedicationTable";
export default {
	name: "Medication",
	components: { MedicationTable },
	data() {
		return {};
	},
	computed: {},
	mounted() { },
	methods: {},
};
</script>
  
<style lang="scss" scoped></style>
  